module.exports = __webpack_public_path__ + "img/watering.df99259f.gif";